import { render, staticRenderFns } from "./spotter_dashboard.vue?vue&type=template&id=5c8c2a58&"
import script from "./spotter_dashboard.vue?vue&type=script&lang=js&"
export * from "./spotter_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./spotter_dashboard.vue?vue&type=style&index=0&id=5c8c2a58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports